/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div class="mb-5 pb-5">
    <div v-if="agronomoSelecionado.item != null">
      <b-badge v-if="isSaldoReceitaAbaixoAlerta(agronomoSelecionado.item)" class="mt-2" variant="danger"><span
          class="h5 text-white">Saldo Receitas:
          {{ agronomoSelecionado.item.receita_art_disponivel }}</span></b-badge>
      <b-badge v-else class="mt-2" variant="primary"><span class="h5 text-white">Saldo Receitas Por ART:
          {{ agronomoSelecionado.item.receita_art_disponivel }}</span></b-badge>
    </div>
    <div class="row" v-show="itemReceita == null">
      <div class="col-md-12">
        <div class="borda"></div>
        <div v-if="!complementarSempreAtiva" class="row">
          <div class="col-md-6">
            <b-form-group>
              <b-form-checkbox v-model="receita.complementar">
                Marcar como receita complementar
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Responsável Técnico" label-for="filter">
              <template v-if="!separarArtPorTecnico" slot="description">
                <b v-if="agronomoSelecionado.item != null">CREA: {{ agronomoSelecionado.item.crea }}</b>
              </template>
              <v-select v-if="!separarArtPorTecnico" class="style-select" label="nome" :options="agronomos"
                :reduce="(item) => item" :dense="true" v-model="agronomoSelecionado.item"
                @input="$forceUpdate()"></v-select>
              <v-select v-else class="style-select" label="nome" :options="agronomosAgrupados" :reduce="(item) => item"
                :dense="true" v-model="agronomoBaseSelecionado" @input="handleSelecionarResponsavelTecnico"></v-select>
            </b-form-group>
          </div>
          <div v-if="separarArtPorTecnico" class="col-md-6">
            <b-form-group id="input-group-art" label="ART" label-for="filter-art">
              <v-select class="style-select" :options="artOptionsByTecnico" :reduce="(item) => item" :dense="true"
                v-model="agronomoSelecionado.item" @input="handleSelecionarArt">
                <template #option="item">
                  <span>{{ getAgronomoArtLabel(item) }}</span>
                </template>
                <template #selected-option="item">
                  <span>{{ getAgronomoArtLabel(item) }}</span>
                </template>
              </v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div :class="complementarSempreAtiva ? 'col-md-8' : 'col-md-6'">
            <b-form-group id="input-group-1" label="Produtor" label-for="filter">
              <div class="produtor-autocomplete">
                <b-form-input v-model="produtorAutocompleteTerm" autocomplete="off"
                  placeholder="Digite para buscar produtores" @input="handleProdutorAutocompleteInput"
                  @change="syncProdutorSelecionadoFromTerm" @focus="handleProdutorAutocompleteFocus"
                  @blur="handleProdutorAutocompleteBlur" />
                <div v-if="showProdutorAutocomplete" class="produtor-autocomplete-menu">
                  <div v-if="isLoadingProdutores" class="produtor-autocomplete-state">
                    Buscando produtores...
                  </div>
                  <button v-for="item in produtores" v-else :key="item.id_produtor_rural" type="button"
                    class="produtor-autocomplete-item" @mousedown.prevent="handleSelecionarProdutor(item)">
                    <span class="produtor-autocomplete-name">{{ item.nome }}</span>
                    <span v-if="item.endereco" class="produtor-autocomplete-meta">{{ item.endereco }}</span>
                  </button>
                  <div v-if="!isLoadingProdutores && !produtores.length" class="produtor-autocomplete-state">
                    Nenhum produtor encontrado.
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
          <div :class="complementarSempreAtiva ? 'col-md-4' : 'col-md-6'">
            <b-form-group id="input-group-1" label="Data de Emissão" label-for="input-2">
              <b-form-datepicker id="datepicker-final" v-model="dataEmissaoReceituario" placeholder="Data de emissão"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="pt-br">
                <template v-slot:button-content>
                  <b-icon icon="calendar" variant="primary"></b-icon>
                </template>
              </b-form-datepicker>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="receita.complementar || complementarSempreAtiva">
          <div class="col-md-4">
            <b-form-group label="Número da Receita Origem">
              <b-form-input v-model="receita.receitaOrigem" type="text" />
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="ART Origem">
              <b-form-input v-model="receita.artOrigem" type="text" />
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Data NF Origem">
              <b-form-input v-model="receita.dataNfOrigem" type="date" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="NF" label-for="input-nf">
              <template slot="description">
                <b>Insira o número da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model="receita.nf"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Série" label-for="input-nf">
              <template slot="description">
                <b>Insira a série da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model="receita.serie_nf"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor R$" label-for="input-nf">
              <template slot="description">
                <b>Insira o valor R$ da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model.lazy="receita.valor_nf" v-money="money"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="item-form-inline-hint">
              Selecione primeiro o responsável tecnico e o produtor para consultar produto, cultura e alvo.
            </div>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Produto" label-for="filter">
              <template slot="description">
                <b v-if="!hasProdutorSelecionado()">Primeiro selecione o produtor</b>
              </template>
              <v-select class="style-select" label="nomeProduto" :options="produtos" :reduce="(item) => item.idProduto"
                :dense="true" @input="handleConsultarCultura" :disabled="!hasProdutorSelecionado()">
              </v-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Culturas" label-for="filter">
              <template slot="description">
                <b v-if="!hasProdutorSelecionado()">Primeiro selecione o produtor</b>
                <b v-else-if="filter.id_produto == null || filter.id_produto.length === 0
                ">Primeiro selecione o produto</b>
              </template>
              <v-select class="style-select" label="nomeComum" :options="culturas" :reduce="(item) => item.idCultura"
                :dense="true" @input="handleConsultarAlvos" :disabled="hasProdutorSelecionado() && filter.id_produto != null && filter.id_produto > 0
                  ? false
                  : true
                  "></v-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Alvo" label-for="filter">
              <template slot="description">
                <b v-if="!hasProdutorSelecionado()">Primeiro selecione o produtor</b>
                <b v-else-if="filter.id_cultura == null || filter.id_cultura.length === 0
                ">Primeiro selecione a cultura</b>
              </template>
              <v-select class="style-select" label="nomeComum" :options="alvos" :reduce="(item) => item.idAlvo"
                :dense="true" @input="handleConsultarRelacao" :disabled="hasProdutorSelecionado() && filter.id_produto > 0 && filter.id_cultura > 0 ? false : true
                  "></v-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <div class="borda"></div>

    <div v-show="itemReceita == null && itens.length > 0">
      <b-table striped hover responsive borderless bordered outlined small :items="itens" :fields="itensFields"
        :per-page="perPage" caption-top>
        <template v-slot:cell(nomeComumAlvo)="row">
          {{ row.item.nomeComumAlvo }} - {{ row.item.nomeCientificoAlvo }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-group mb-2">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="uil uil-ellipsis-v"></i>
              </template>
              <!-- <b-dropdown-item @click="editReceita(row.item)"
                >Editar</b-dropdown-item
              > -->
              <b-dropdown-item @click="modalDeleteItemReceita(row.item.idReceitaItem)">Excluir</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col-sm-1 col-1">
          <button class="btn btn-primary" @click="handleEmitirReceita()">
            <span>Emitir</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="itemReceita == null"> </div>
    <div v-else>
      <div v-if="true" class="item-editor item-editor-complementar shadow-sm mb-5 rounded">
        <div class="item-summary-grid">
          <div class="item-summary-card item-summary-wide">
            <div class="summary-pill-group">
              <span class="summary-value summary-pill">{{ this.itemReceita.produto.nome }} ({{
                this.itemReceita.ingredientes.join(' ') }})</span>
              <span class="summary-value summary-pill">{{ this.itemReceita.cultura.nomeComumCultura }} - {{
                this.itemReceita.cultura.nomeCientificoCultura }}</span>
              <span class="summary-value summary-pill">{{ this.itemReceita.praga.nomeComumPraga }} - {{
                this.itemReceita.praga.nomeCientificoPraga }}</span>
            </div>
          </div>
          <div class="item-summary-card">
            <div class="summary-inline-pairs">
              <div class="summary-inline-pair">
                <span class="summary-label">Responsável Técnico</span>
                <span class="summary-value">{{ this.agronomoSelecionado.item.nome }}</span>
              </div>
              <div class="summary-inline-pair">
                <span class="summary-label">Produtor</span>
                <span class="summary-value">{{ this.produtorSelecionado.item.nome }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item-editor-section">
          <div class="item-editor-section-head">
            <div>
              <h5 class="item-editor-section-title">Configuração da aplicação</h5>
              <p class="item-editor-section-text">Defina o equipamento e revise os dados operacionais desta aplicação.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <b-form-group id="input-equipamento-aplicacao" label="Equipamento de aplicação" label-for="filter">
                <v-select class="style-select" label="nome" :options="equipamentos" :reduce="(item) => item"
                  :dense="true" v-model="equipamentoSelecionado" @input="$forceUpdate()"></v-select>
              </b-form-group>
            </div>
            <div v-if="complementarSempreAtiva" class="col-lg-4">
              <b-form-group label="Lote" label-for="input-lote">
                <b-form-input id="input-lote" v-model="itemReceita.lote" type="text"
                  placeholder="Informe o lote"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="item-editor-section">
          <div class="item-editor-section-head">
            <div>
              <h5 class="item-editor-section-title">Parâmetros da receita</h5>
              <p class="item-editor-section-text">Preencha os dados operacionais da receita e ajuste as quantidades
                quando
                necessário.</p>
            </div>
            <div class="item-editor-inline-note">
              Selecione a unidade do produto para calcular a área a tratar.
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-4">
              <b-form-group label="Nº aplicação" label-for="input-numero-aplicacao">
                <template slot="description"><b>Número de aplicação de
                    {{ this.itemReceita.numeroAplicacoesMin }} até
                    {{ this.itemReceita.numeroAplicacoesMax }}</b></template>
                <b-form-input v-model="$v.itemReceita.nAplicacoes.$model" :state="validateState('nAplicacoes')"
                  type="text"></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback">O Número de aplicação é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-md-4">
              <b-form-group label="Dose" label-for="input-numero-aplicacao">
                <template slot="description">
                  <b>Dose de {{ this.itemReceita.doseMin }} até
                    {{ this.itemReceita.doseMax }}
                    {{ this.itemReceita.desc_unidade }}</b>
                </template>
                <b-form-input type="text" v-model="$v.itemReceita.dose.$model"
                  :state="validateState('dose')"></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback">A dose é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-md-4">
              <b-form-group label="Volume de calda" label-for="input-calda">
                <template slot="description"><b>Volume de Calda de
                    {{ this.itemReceita.volumeCaldaMinReferencia || this.itemReceita.volumeCaldaMin }} até
                    {{ this.itemReceita.volumeCaldaReferencia || this.itemReceita.volumeCalda }}
                    {{ this.itemReceita.desc_unidade_calda }}</b></template>
                <b-form-input type="text" v-model="$v.itemReceita.volumeCalda.$model"
                  :state="validateState('volumeCalda')"></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback">O volume de calda é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-md-2">
              <b-form-group label="Qtde." label-for="input-qtde">
                <b-form-input type="text" v-model="$v.itemReceita.qtdeAdquirir.$model"
                  :state="validateState('qtdeAdquirir')" @blur="queueAreaCalculation"></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback">A quantidade adquirida é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-md-4">
              <b-form-group label="Unidade" label-for="select-unidade">
                <b-form-select id="select-unidade" :options="unidadesMedida" v-model="$v.itemReceita.unidade.$model"
                  :state="validateState('unidade')" @input="queueAreaCalculation">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecione…</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback>
                  A unidade é obrigatória.
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-md-4">
              <b-form-group :label="getAreaAplicacaoLabel()" label-for="input-qtde">
                <template slot="description">
                  <b v-if="areaCalculationMessage">{{ areaCalculationMessage }}</b>
                </template>
                <b-form-input type="text" v-model="$v.itemReceita.areaAplicacao.$model"
                  :state="validateState('areaAplicacao')"></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback">A área de aplicação é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="item-editor-section">
          <div class="item-editor-section-head">
            <div>
              <h5 class="item-editor-section-title">Instruções da aplicação</h5>
              <p class="item-editor-section-text">Revise o modo de uso e complemente as orientações quando necessário.
              </p>
            </div>
          </div>
          <div class="row item-textareas-row">
            <div class="col-lg-4">
              <b-form-group id="input-group-1" label="Modo de aplicação" label-for="input-2">
                <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                  placeholder="Modo de aplicação" v-model="$v.itemReceita.descModoAplicacao.$model"
                  :state="validateState('descModoAplicacao')"></b-form-textarea>
                <b-form-invalid-feedback id="input-2-live-feedback">O modo de aplicação é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group id="input-group-1" label="Recomendações de uso" label-for="input-2">
                <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                  placeholder="Recomendações de uso" v-model="$v.itemReceita.descRecomendacoes.$model"
                  :state="validateState('descRecomendacoes')"></b-form-textarea>
                <b-form-invalid-feedback id="input-2-live-feedback">A recomentação é
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group id="input-group-1" label="Recomendações adicionais (opcional)" label-for="input-2">
                <textarea class="form-control" id="input-2" rows="5" v-model="itemReceita.obs" type="text"
                  placeholder="Recomendações adicionais (opcional)" required></textarea>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="item-editor-actions">
              <button class="btn btn-danger mr-2" @click="itemReceita = null">
                Cancelar
              </button>
              <button class="btn btn-primary" @click="criarReceita()">
                Adicionar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="shadow p-3 mb-5 bg-white rounded">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Produto:</b>
                  {{ this.itemReceita.produto.nome }} ({{
                    this.itemReceita.ingredientes.join(' ')
                  }})
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Cultura:</b>
                  {{ this.itemReceita.cultura.nomeComumCultura }} -
                  {{ this.itemReceita.cultura.nomeCientificoCultura }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Alvo:</b>
                  {{ this.itemReceita.praga.nomeComumPraga }} -
                  {{ this.itemReceita.praga.nomeCientificoPraga }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Responsável Técnico:</b>
                  {{ this.agronomoSelecionado.item.nome }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Produtor:</b>
                  {{ this.produtorSelecionado.item.nome }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-10">
                <b v-if="itemReceita.msgArea ===
                  'É necessário informar área manualmente.'
                ">É necessário informar área de aplicação manualmente.</b>
                <b v-else-if="itemReceita.msgArea === 'Não é necessário informar área.'
                ">Não é necessário informar área de aplicação.</b>
                <b v-else>O cálculo da área de aplicação é feito automaticamente quando
                  informado a quantidade do Produto.</b>
              </div>
              <div v-show="this.$store.state.auth.currentUser.user === 'agro_borges'" class="col-md-2"><b-link
                  @click="$bvModal.show('modal-doses')"><b>Ver doses</b></b-link></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group id="input-equipamento-aplicacao" label="Equipamento de aplicação" label-for="filter">
              <v-select class="style-select" label="nome" :options="equipamentos" :reduce="(item) => item" :dense="true"
                v-model="equipamentoSelecionado" @input="$forceUpdate()"></v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="complementarSempreAtiva" class="col-md-4">
            <b-form-group label="Lote" label-for="input-lote">
              <b-form-input id="input-lote" v-model="itemReceita.lote" type="text"
                placeholder="Informe o lote"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group label="Nº aplicação" label-for="input-numero-aplicacao">
              <template slot="description"><b>Número de aplicação de
                  {{ this.itemReceita.numeroAplicacoesMin }} até
                  {{ this.itemReceita.numeroAplicacoesMax }}</b></template>
              <b-form-input v-model="$v.itemReceita.nAplicacoes.$model" :state="validateState('nAplicacoes')"
                type="text"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">O Número de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Dose" label-for="input-numero-aplicacao">
              <template slot="description">
                <b>Dose de {{ this.itemReceita.doseMin }} até
                  {{ this.itemReceita.doseMax }}
                  {{ this.itemReceita.desc_unidade }}</b>
              </template>
              <b-form-input type="text" v-model="$v.itemReceita.dose.$model"
                :state="validateState('dose')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A dose é obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Volume de calda" label-for="input-calda">
              <template slot="description"><b>Volume de Calda de
                  {{ this.itemReceita.volumeCaldaMinReferencia || this.itemReceita.volumeCaldaMin }} até
                  {{ this.itemReceita.volumeCaldaReferencia || this.itemReceita.volumeCalda }}
                  {{ this.itemReceita.desc_unidade_calda }}</b></template>
              <b-form-input type="text" v-model="$v.itemReceita.volumeCalda.$model"
                :state="validateState('volumeCalda')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">O volume de calda é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Qtde." label-for="input-qtde">
              <b-form-input type="text" v-model="$v.itemReceita.qtdeAdquirir.$model"
                :state="validateState('qtdeAdquirir')" @blur="queueAreaCalculation"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A quantidade adquirida é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Unidade" label-for="select-unidade">
              <b-form-select id="select-unidade" :options="unidadesMedida" v-model="$v.itemReceita.unidade.$model"
                :state="validateState('unidade')" @input="queueAreaCalculation">
                <template #first>
                  <b-form-select-option :value="null" disabled>Selecione…</b-form-select-option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>
                A unidade é obrigatória.
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group :label="getAreaAplicacaoLabel()" label-for="input-qtde">
              <template slot="description">
                <b v-if="areaCalculationMessage">{{ areaCalculationMessage }}</b>
              </template>
              <b-form-input type="text" v-model="$v.itemReceita.areaAplicacao.$model"
                :state="validateState('areaAplicacao')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A área de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <div class="row"> </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Modo de aplicação" label-for="input-2">
              <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                placeholder="Modo de aplicação" v-model="$v.itemReceita.descModoAplicacao.$model"
                :state="validateState('descModoAplicacao')"></b-form-textarea>
              <b-form-invalid-feedback id="input-2-live-feedback">O modo de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Recomendações de uso" label-for="input-2">
              <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                placeholder="Recomendações de uso" v-model="$v.itemReceita.descRecomendacoes.$model"
                :state="validateState('descRecomendacoes')"></b-form-textarea>
              <b-form-invalid-feedback id="input-2-live-feedback">A recomentação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Recomendações adicionais (opcional)" label-for="input-2">
              <textarea class="form-control" id="input-2" rows="5" v-model="itemReceita.obs" type="text"
                placeholder="Recomendações adicionais (opcional)" required></textarea>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-2">
            <button class="btn btn-danger mr-2" @click="itemReceita = null">
              Cancelar
            </button>
            <button class="btn btn-primary" @click="criarReceita()">
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-relacao" :title="titleModalRelacao" title-class="font-18" size="lg" scrollable
      :hide-footer="true">
      <div class="shadow p-3 mb-3 bg-white rounded" v-for="relacao in relacoes" :key="relacao.id">
        <div class="row">
          <div class="col-md-6">
            <label>
              <b>Produto:</b>
              {{ relacao.nome }} ({{ relacao.ingredientes.join(' ') }})
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Classe Toxicológica:</b>
              {{ relacao.classeToxicologica }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>
              <b>Cultura:</b>
              {{ relacao.nomeComumCultura }} -
              {{ relacao.nomeCientificoCultura }}
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <b>Estágio:</b>
              {{ relacao.epocaCultura }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Diagnóstico:</b>
              {{ relacao.nomeComumPraga }} - {{ relacao.nomeCientificoPraga }}
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Estágio:</b>
              {{ relacao.epocaPraga }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Local de aplicação:</b>
              {{ relacao.localAplicacao }}
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Tipo de Aplicacao:</b>
              {{ relacao.tipoAplicacao }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <b-form-fieldset :feedback="feedback" label="Dosagens" :label-size="1">
                  <div class="row">
                    <div class="col-12">
                      <label>
                        <b>Mín:</b>
                        {{ relacao.doseMin }} {{ relacao.unidadeAplicacao }}
                      </label>
                    </div>
                    <div class="col-12">
                      <label>
                        <b>Máx:</b>
                        {{ relacao.doseMax }} {{ relacao.unidadeAplicacao }}
                      </label>
                    </div>
                  </div>
                </b-form-fieldset>
              </div>
              <div class="col-6">
                <b-form-fieldset :feedback="feedback" label="Aplicações" :label-size="1">
                  <div class="row">
                    <div class="col-12">
                      <label>
                        <b>Mínima:</b>
                        {{ relacao.numeroAplicacoesMin }}
                      </label>
                    </div>
                    <div class="col-12">
                      <label>
                        <b>Máxima:</b>
                        {{ relacao.numeroAplicacoesMax }}
                      </label>
                    </div>
                  </div>
                </b-form-fieldset>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Volume de calda:</b>
              {{ relacao.volumeCalda }} {{ relacao.unidadeCultura }}
            </label>
          </div>
          <div class="col-4">
            <label>
              <b>Intervalo de segurança:</b>
              {{ relacao.intervaloSeguranca }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>Modo/Época de aplicação:</b>
              {{ relacao.descModoAplicacao }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>EPI:</b>
              {{ relacao.descEpi }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>Precaução de uso:</b>
              {{ relacao.descPrecaucaoUso }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button class="btn btn-primary btn-block" @click="selecionarRelacao(relacao)">
              <span>Selecionar</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="modalDelItem" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir o item da receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modalDelItem = false">Não</b-button>
        <b-button variant="danger" @click="handleDeleteItemReceita">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-doses" title="Doses para 20 L">
      <p class="my-4">
        ☑️ Magafol: 50 ml <br>
        ☑️ Sumyzin: 20 ml geral, para amendoim, 7 ml, fazer a pulverização em dias sem previsão de chuva<br>
        ☑️ Tenaz: 70 ml para 20 L. Para banana 1 ml (por planta na axila da terceira folha para o combate a
        Sigatoka)<br>
        ☑️ Tordon ultra-s: 100 ml, para plantas de mais fácil controle, para plantas de mais difícil controle, 150
        ml.<br>
        ☑️ Adesil: 10 ml (último a ser colocado na calda)<br>
        ☑️ Roundup original mais: 150 ml<br>
        ☑️ Nativo: 12 ml, pode ser utilizado como Tenaz para banana<br>
        ☑️ Padron: 300 ml<br>
        ☑️ Connect: 20 ml<br>
        ☑️ Galil: 10 ml<br>
        ☑️ Artys: 200 ml, para plantas de mais fácil controle, para plantas de mais difícil controle, 300 ml.<br>
        ☑️ Decis: 10 ml<br>
        ☑️ Zartan: Interessante de se utilizar com plantas de folhas pequenas como carquejas e vassourinhas. Diluir 1
        pacote em 1 L de água e utilizar 200 ml da mistura por bomba, tomar cuidado com culturas perenes como citrus,
        cacau e banana, pode causar fitotoxidez, se for utilizado com Roundup<br>
        ☑️ Brexil: 40 g<br>
        ☑️ Roundup ultra em pó: 100 g</p>
    </b-modal>

    <b-modal id="modal-regra-produtos-receita" title="Aviso" title-class="font-18" hide-footer>
      <div v-if="regraProdutosReceitaDetalhe" class="regra-produto-modal">        

        <div v-if="regraProdutosReceitaDetalhe.resumo" class="regra-produto-bloco">
          <p v-if="regraProdutosReceitaDetalhe.regra && regraProdutosReceitaDetalhe.regra.regra">{{ regraProdutosReceitaDetalhe.regra.regra }}</p>
          <p v-if="regraProdutosReceitaDetalhe.regra && regraProdutosReceitaDetalhe.regra.fundamentoLegal" class="regra-produto-fundamento">
            {{ regraProdutosReceitaDetalhe.regra.fundamentoLegal }}
          </p>
        </div>
      </div>
      <div class="text-right mt-3">
        <b-button variant="primary" @click="$bvModal.hide('modal-regra-produtos-receita')">Entendi</b-button>
      </div>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import formProdutor from '@/src/components/form-produtor'
import relReceita from '@src/components/rel-receita.vue'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

import receitaService from '@/src/services/receita'
import produtorRural from '@src/services/produtor-rural'
import agronomoService from '@/src/services/agronomo'
import configuracoesService from '@/src/services/api-receituario/configuracao'

import moment from 'moment'
import ItemReceita from '../services/request/item-receita'
import estoqueService from '@/src/services/api-receituario/estoque'
moment.locale('pt-br')
import { validationMixin } from 'vuelidate'
import { required, minLength, requiredIf } from 'vuelidate/lib/validators'
const greaterThanZero = (value) => value > 0
const TEMP_DISABLE_PRODUCT_RULE_VALIDATION = true
var currencyFormatter = require('currency-formatter')
import { VMoney } from 'v-money'
const momentTimeZone = require('moment-timezone');

/**
 * Produtor rural Component
 */
export default {
  mixins: [validationMixin],
  directives: { mask, money: VMoney },
  components: {
    Layout,
    Loading,
    formProdutor,
    DatePicker,
    relReceita,
  },
  props: {
    receita: {},
    separarArtPorTecnico: {
      type: Boolean,
      default: false,
    },
    complementarSempreAtiva: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      receita: this.$props.receita,
      idItemReceita: null,
      receitas: [],
      alvos: [],
      produtos: [],
      culturas: [],
      produtores: [],
      produtoresTotalDisponivel: 0,
      produtorSearchDebounce: null,
      produtorAutocompleteTerm: '',
      showProdutorAutocomplete: false,
      agronomos: [],
      agronomosAgrupados: [],
      relacoes: [],
      itens: [],
      produtorSelecionado: {},
      agronomoSelecionado: {},
      agronomoBaseSelecionado: null,
      itemReceita: null,
      relacaoSelecionada: null,
      mostraForm: true,
      relatorioReceita: {},
      idReceita: null,
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      rows: 0,
      itensReceita: [ItemReceita],
      filter: {
        id_pragas: '',
        id_cultura: '',
        id_produto: '',
      },
      itensFields: [
        {
          key: 'nomeProduto',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'nomeComumCultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
        {
          key: 'nomeComumAlvo',
          label: 'Diagnóstico',
          class: 'size-col-50',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      modalDelItem: false,
      qtdeReceitaAlertaArt: 10,
      emailAlertaArtConfigurado: '',
      configAlertaArtValida: false,
      envioAlertaArtAutomaticoExecutado: false,
      titleModalRelacao: '',
      dataEmissaoReceituario: new Date(),
      areaCalculationMessage: '',
      areaCalculationDebounce: null,
      relacoesAtuaisReceita: [],
      regraProdutosReceitaDetalhe: null,
      equipamentoSelecionado: {},
      unidadesMedida: [
        { value: 'kg', text: 'kg' },
        { value: 'g', text: 'g' },
        { value: 'L', text: 'L' },
        { value: 'mL', text: 'mL' },
        { value: 'Fr', text: 'Frasco' },
        { value: 'Gl', text: 'Galão' },
      ],
      equipamentos:
        [
          {
            "id_tipo_aplicacao": 1,
            "nome": "Plantio direto",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 2,
            "nome": "Plantio convencional",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 3,
            "nome": "Sequeiro",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 4,
            "nome": "Irrigado",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 5,
            "nome": "Rasteiro",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 6,
            "nome": "Tutorado",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 7,
            "nome": "Cana-planta",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 8,
            "nome": "Cana-soca",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 9,
            "nome": "Aplicação sequencial",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 10,
            "nome": "Primeira aplicação",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 11,
            "nome": "Segunda aplicação",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 12,
            "nome": "Aplicação sequencial - 4 aplicações",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 13,
            "nome": "Aplicação localizada",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 14,
            "nome": "Aplicação dirigida (equipamento costal)",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 15,
            "nome": "sachet de 34 g\/5,66 m³",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 16,
            "nome": "Pastilhas de 3g \/ m³",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 17,
            "nome": "Comprimidos de 0,6g \/ m³ ",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 18,
            "nome": "Pulverização",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 19,
            "nome": "Plantio direto",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 20,
            "nome": "Plantio convencional",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 21,
            "nome": "Sequeiro",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 22,
            "nome": "Irrigado",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 23,
            "nome": "Rasteiro",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 24,
            "nome": "Tutorado",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 25,
            "nome": "Cana-planta",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 26,
            "nome": "Cana-soca",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 27,
            "nome": "Aplicação sequencial",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 28,
            "nome": "Primeira aplicação",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 29,
            "nome": "Segunda aplicação",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 30,
            "nome": "Aplicação sequencial - 4 aplicações",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 31,
            "nome": "Aplicação localizada",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 32,
            "nome": "Aplicação dirigida (equipamento costal)",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 33,
            "nome": "sachet de 34 g\/5,66 m³",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 34,
            "nome": "Pastilhas de 3g \/ m³",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 35,
            "nome": "Comprimidos de 0,6g \/ m³ ",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 36,
            "nome": "Pulverização",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2020-10-13"
          },
          {
            "id_tipo_aplicacao": 37,
            "nome": "Tratamento de Sementes",
            "data_cadastro": "2017-03-16",
            "data_atualizacao": "2017-03-16"
          },
          {
            "id_tipo_aplicacao": 38,
            "nome": "Aplicação em Área Total",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 39,
            "nome": "Manutenção (pastagens)",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 40,
            "nome": "Reforma (pastagens)",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 41,
            "nome": "Aplicação Aérea",
            "data_cadastro": "2019-04-16",
            "data_atualizacao": "2019-04-16"
          },
          {
            "id_tipo_aplicacao": 42,
            "nome": "Imersão",
            "data_cadastro": "2019-05-07",
            "data_atualizacao": "2019-05-07"
          },
          {
            "id_tipo_aplicacao": 43,
            "nome": "Aplicação única",
            "data_cadastro": "2019-10-29",
            "data_atualizacao": "2019-10-29"
          },
          {
            "id_tipo_aplicacao": 44,
            "nome": "Esguicho (drench)",
            "data_cadastro": "2020-05-10",
            "data_atualizacao": "2020-05-10"
          },
          {
            "id_tipo_aplicacao": 45,
            "nome": "Aplicação Solos Arenosos",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 46,
            "nome": "Aplicação Solos Médios",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 47,
            "nome": "Aplicação Solos Argilosos",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 48,
            "nome": "Rega",
            "data_cadastro": "2020-09-02",
            "data_atualizacao": "2020-09-02"
          },
          {
            "id_tipo_aplicacao": 49,
            "nome": "Dessecação",
            "data_cadastro": "2021-03-27",
            "data_atualizacao": "2021-03-27"
          },
          {
            "id_tipo_aplicacao": 50,
            "nome": "Pulverizador costal ou de barra",
            "data_cadastro": "2022-07-06",
            "data_atualizacao": "2022-07-06"
          },
          {
            "id_tipo_aplicacao": 51,
            "nome": "Atomizador costal motorizado"
          },
          {
            "id_tipo_aplicacao": 52,
            "nome": "Atomizador canhão modelo AF 427 bananeiro"
          },
          {
            "id_tipo_aplicacao": 53,
            "nome": "Pulverizadores manuais"
          },
          {
            "id_tipo_aplicacao": 54,
            "nome": "Pulverização costal",
            "data_atualizacao": "2022-07-06"
          },
          {
            "id_tipo_aplicacao": 55,
            "nome": "Pulverizador estacionário com mangueira"
          },
          {
            "id_tipo_aplicacao": 56,
            "nome": "Pulverizador tratorizado"
          },
          {
            "id_tipo_aplicacao": 57,
            "nome": "Pulverizador turboatomizadores"
          },
          {
            "id_tipo_aplicacao": 58,
            "nome": "Pulverização de barra horizontal"
          },
          {
            "id_tipo_aplicacao": 59,
            "nome": "Pulverização de barra vertical"
          },
          {
            "id_tipo_aplicacao": 60,
            "nome": "Pulverização tratorizada com barra"
          },
          {
            "id_tipo_aplicacao": 61,
            "nome": "Imersão"
          },
          {
            "id_tipo_aplicacao": 62,
            "nome": "ISCA"
          },
          {
            "id_tipo_aplicacao": 63,
            "nome": "Armadilha"
          },
          {
            "id_tipo_aplicacao": 64,
            "nome": "Geração de gás"
          },
          {
            "id_tipo_aplicacao": 65,
            "nome": "Aplicação ARP (Drones)"
          },
          {
            "id_tipo_aplicacao": 66,
            "nome": "Pulverizador Tratorizada de Tocos"
          },
          {
            "id_tipo_aplicacao": 67,
            "nome": "Tambores rotativos"
          },
          {
            "id_tipo_aplicacao": 68,
            "nome": "Pulverizadores costais"
          },
          {
            "id_tipo_aplicacao": 69,
            "nome": "Pulverizadores de barra acoplados a tratores"
          },
          {
            "id_tipo_aplicacao": 70,
            "nome": "Pulverizadores de mangueira"
          },
          {
            "id_tipo_aplicacao": 71,
            "nome": "Atomizadores (turbo-atomizadores)"
          },
          {
            "id_tipo_aplicacao": 72,
            "nome": "Pulverizadores acoplados ao trator"
          },
          {
            "id_tipo_aplicacao": 73,
            "nome": "Turbo pulverizador e gotas médias a médias\/grossas"
          },
          {
            "id_tipo_aplicacao": 74,
            "nome": "Pulverizadores costais (manual ou motorizado)"
          },
          {
            "id_tipo_aplicacao": 75,
            "nome": "Pulverizador manual ou tratorizado de barra"
          },
          {
            "id_tipo_aplicacao": 76,
            "nome": "Aéreo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 77,
            "nome": "Barra Costal",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 78,
            "nome": "Pistolas de jato regulável",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 79,
            "nome": "Terrestre",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 80,
            "nome": "Costal Turbo Atomizador",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 81,
            "nome": "Avião",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 82,
            "nome": "Gotejo no solo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 83,
            "nome": "Esguicho no solo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 84,
            "nome": "Gotejamento",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 85,
            "nome": "Pulverizadores específicos",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 86,
            "nome": "Imersão de mudas",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 87,
            "nome": "Avião Ipanema",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 88,
            "nome": "Equipamento de rosca sem fim",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 89,
            "nome": "Aplicação terrestre",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 90,
            "nome": "Equipamento costal manual",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 91,
            "nome": "Auto-propelido",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 92,
            "nome": "Atomizador motorizado costal ou tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 93,
            "nome": "Pistola dosadora de haste longa",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 94,
            "nome": "Equipamento costal ou acoplado a tratores",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 95,
            "nome": "Sistema convencional com barra",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 96,
            "nome": "Jato dirigido \/ Esguicho (Drench)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 97,
            "nome": "Não determinado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 98,
            "nome": "Aeronaves agrícolas",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 99,
            "nome": "Tubo atomizador acoplado ao trator",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 100,
            "nome": "Aplicação baixo volume (BV)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 101,
            "nome": "Pulverizações a volumes normais",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 102,
            "nome": "Costal e tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 103,
            "nome": "Betoneiras",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 104,
            "nome": "Equipamentos com fluxo contínuo",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 105,
            "nome": "Terrestre tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 106,
            "nome": "Terrestre tratorizado convencional",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 107,
            "nome": "Equipamento mecanizado (Roçaplic)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 108,
            "nome": "Costal estacionário",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 109,
            "nome": "Turbo atomizadores tratorizados",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 110,
            "nome": "Pistolas de pulverização",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 111,
            "nome": "Equipamento Bentley (Eliminação de soqueira)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 112,
            "nome": "Costal (Capina\/Catação química)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 113,
            "nome": "Aeronaves agrícolas (como maturador)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 114,
            "nome": "Terrestres em jato-dirigido",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 115,
            "nome": "Regador",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 116,
            "nome": "Pulverizador autopropelido ou tratorizado de barra (jato dirigido)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 117,
            "nome": "Pulverizador costal pressurizado",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 118,
            "nome": "Drones (ARP)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 119,
            "nome": "Aéreo (como maturador)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 120,
            "nome": "Sistema de irrigação - Pivô central",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 121,
            "nome": "Atomizadores ou pulverizadores tracionados",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 122,
            "nome": "Batelada",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 123,
            "nome": "Bicos centrífugos (atomizadores rotativos)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 124,
            "nome": "Montados ou tracionados por trator",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 125,
            "nome": "Equipamento acoplado a tratores",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 126,
            "nome": "Máquinas específicas para tratamento de sementes",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 127,
            "nome": "Máquinas específicas com fluxo contínuo de sementes",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 174,
            "nome": "Pulverizador manual ou tratorizado",
            "data_cadastro": null,
            "data_atualizacao": null
          },
          {
            "id_tipo_aplicacao": 141,
            "nome": "Granuladeiras",
            "data_cadastro": null,
            "data_atualizacao": null
          },
          {
            "id_tipo_aplicacao": 176,
            "nome": "Jato dirigido",
            "data_cadastro": null,
            "data_atualizacao": null
          }
        ]
    }
  },
  validations: {
    itemReceita: {
      nAplicacoes: {
        required,
        minLength: minLength(1),
      },
      dose: {
        required,
        minLength: minLength(1),
      },
      qtdeAdquirir: {
        required,
        maxValue: greaterThanZero,
      },
      unidade: {
        required
      },
      areaAplicacao: {
        required: requiredIf(function () {
          return this.itemReceita.calculaArea
        }),
      },
      volumeCalda: {
        required: requiredIf(function () {
          return this.isVolumeCaldaObrigatorio()
        }),
      },
      descRecomendacoes: {
        required,
        minLength: minLength(1),
      },
      descModoAplicacao: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {
    artOptionsByTecnico() {
      if (!this.separarArtPorTecnico || !this.agronomoBaseSelecionado) return []

      return (this.agronomos || []).filter((agronomo) => {
        return this.getAgronomoGroupKey(agronomo) === this.agronomoBaseSelecionado.key
      })
    },
  },
  watch: {
    'itemReceita.nAplicacoes'() {
      this.queueAreaCalculation()
    },
    'itemReceita.dose'() {
      this.queueAreaCalculation()
    },
    'itemReceita.volumeCalda'() {
      this.queueAreaCalculation()
    },
    'itemReceita.qtdeAdquirir'() {
      this.queueAreaCalculation()
    },
    'itemReceita.unidade'() {
      this.queueAreaCalculation()
    },
  },
  async mounted() {
    if (this.complementarSempreAtiva) {
      this.receita.complementar = true
    }
    this.loadConfigReceitaAlertaArt()
    this.handleConsultarProdutores()
    this.handleConsultarProduto()
    await this.consultarItemReceita(this.receita.id)
    await this.handleConsultarAgronomo()
    this.produtorSelecionado.item = this.receita.produtor
    this.produtorAutocompleteTerm = this.getProdutorOptionLabel(this.receita.produtor)
    if (this.complementarSempreAtiva) {
      this.receita.complementar = true
    }
  },
  methods: {
    hasProdutorSelecionado() {
      return !!(
        this.produtorSelecionado &&
        this.produtorSelecionado.item &&
        this.produtorSelecionado.item.id_produtor_rural
      )
    },
    notifyProdutorRequired() {
      this.$bvToast.toast('Selecione o produtor antes de pesquisar produto, cultura e alvo.', {
        variant: 'warning',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    getUfSigla() {
      const produtor = this.produtorSelecionado && this.produtorSelecionado.item
        ? this.produtorSelecionado.item
        : {}
      const estadoIdToUf = {
        1: 'AC',
        2: 'AL',
        3: 'AM',
        4: 'AP',
        5: 'BA',
        6: 'CE',
        7: 'DF',
        8: 'ES',
        9: 'GO',
        10: 'MA',
        11: 'MG',
        12: 'MS',
        13: 'MT',
        14: 'PA',
        15: 'PB',
        16: 'PE',
        17: 'PI',
        18: 'PR',
        19: 'RJ',
        20: 'RN',
        21: 'RO',
        22: 'RR',
        23: 'RS',
        24: 'SC',
        25: 'SE',
        26: 'SP',
        27: 'TO',
        28: 'EX',
      }

      const possibleValues = [
        this.receita && this.receita.estado,
        this.receita && this.receita.id_estado,
        produtor.uf,
        produtor.id_estado,
        produtor.sigla_estado,
        produtor.estado,
        produtor.nome_estado,
        produtor.estado_nome,
        produtor.sigla,
        produtor.estado && produtor.estado.sigla,
        produtor.estado && produtor.estado.id_estado,
      ]

      for (const value of possibleValues) {
        if (value === null || value === undefined || value === '') {
          continue
        }

        if (typeof value === 'number' || /^[0-9]+$/.test(String(value).trim())) {
          const ufById = estadoIdToUf[Number(value)]
          if (ufById) {
            return ufById
          }
        }

        const estado = String(value || '').trim()

        if (!estado) {
          continue
        }

        if (/^[A-Z]{2}$/i.test(estado)) {
          return estado.toUpperCase()
        }

        const match = estado.match(/-([A-Z]{2})$/i)
        if (match) {
          return match[1].toUpperCase()
        }
      }

      return ''
    },
    getRelacaoId(item) {
      const possibleIds = [
        item && item.id_item_produto,
        item && item.relacao,
        item && item.idRelacao,
        item && item.id_relacao,
        item && item.idItemProduto,
        item && item.id_item_produto_relacao,
        item && item.idReceitaItem,
        item && item.id,
      ]

      const validId = possibleIds.find((value) => value !== null && value !== undefined && value !== '')
      return validId !== undefined ? Number(validId) : null
    },
    async validarRegrasProdutosPorReceita(relacoes) {
      if (TEMP_DISABLE_PRODUCT_RULE_VALIDATION) {
        return relacoes
      }

      if (!Array.isArray(relacoes) || !relacoes.length) {
        return relacoes
      }

      const relacoesAtuaisFromItens = this.itens
        .map((item) => this.getRelacaoId(item))
        .filter((value) => Number.isFinite(value))

      const relacoesAtuais = Array.from(
        new Set([...relacoesAtuaisFromItens, ...this.relacoesAtuaisReceita])
      )

      if (!relacoesAtuais.length) {
        return relacoes
      }

      const uf = this.getUfSigla()
      if (!uf) {
        this.$bvToast.toast('Não foi possível identificar a UF do produtor para validar as regras desta receita.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return relacoes
      }

      const token = this.$store.state.auth.currentUser.token
      const resultados = await Promise.all(
        relacoes.map(async (relacao) => {
          const novaRelacao = this.getRelacaoId(relacao)

          if (!Number.isFinite(novaRelacao)) {
            return { permitido: true, relacao }
          }

          try {
            const resposta = await receitaService.validarProdutosPorReceita(token, {
              uf,
              relacoesAtuais,
              novaRelacao,
            })

            return {
              ...(resposta && resposta.data ? resposta.data : {}),
              relacao,
            }
          } catch (error) {
            return {
              permitido: false,
              mensagens: ['Não foi possível validar as regras desta relação.'],
              relacao,
            }
          }
        })
      )

      const relacoesPermitidas = resultados
        .filter((resultado) => resultado.permitido)
        .map((resultado) => resultado.relacao)

      if (!relacoesPermitidas.length) {
        const primeiraRegraBloqueada = resultados.find(
          (resultado) => !resultado.permitido && (
            (Array.isArray(resultado.mensagens) && resultado.mensagens.length) ||
            resultado.regra ||
            resultado.resumo
          )
        )

        if (primeiraRegraBloqueada) {
          this.regraProdutosReceitaDetalhe = primeiraRegraBloqueada
          this.$bvModal.show('modal-regra-produtos-receita')
        }

        const mensagens = resultados
          .flatMap((resultado) => Array.isArray(resultado.mensagens) ? resultado.mensagens : [])
          .filter(Boolean)

        // this.$bvToast.toast(
        //   mensagens[0] || 'A combinação selecionada não pode ser adicionada a esta receita.',
        //   {
        //     variant: 'warning',
        //     solid: false,
        //     noCloseButton: true,
        //     toaster: 'b-toaster-top-center',
        //   }
        // )
      }

      return relacoesPermitidas
    },
    normalizeUnitText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    },
    isVolumeCaldaObrigatorio() {
      const unidadeCalda = this.normalizeUnitText(
        this.itemReceita && this.itemReceita.desc_unidade_calda
      )

      if (!unidadeCalda) {
        return this.hasVolumeCaldaReferenciaPositiva()
      }

      const unidadeDispensaVolume = (
        unidadeCalda.includes('m3') ||
        unidadeCalda.includes('m³') ||
        unidadeCalda.includes('metro cubico') ||
        unidadeCalda.includes('metros cubicos')
      )

      return !unidadeDispensaVolume && this.hasVolumeCaldaReferenciaPositiva()
    },
    parseNumberField(value) {
      if (value === null || value === undefined || value === '') {
        return null
      }

      const normalizedValue = String(value).trim().replace(',', '.')
      if (!normalizedValue) {
        return null
      }

      const parsed = Number(normalizedValue)
      return Number.isNaN(parsed) ? null : parsed
    },
    isVolumeCaldaVazioOuZero(value) {
      const parsed = this.parseNumberField(value)
      return parsed === null || parsed === 0
    },
    hasVolumeCaldaReferenciaPositiva() {
      const referencia = [
        this.itemReceita && this.itemReceita.volumeCaldaReferencia,
        this.itemReceita && this.itemReceita.volumeCalda,
        this.itemReceita && this.itemReceita.volumeCaldaMinReferencia,
        this.itemReceita && this.itemReceita.volumeCaldaMin,
      ]

      return referencia.some((value) => {
        const parsed = this.parseNumberField(value)
        return parsed !== null && parsed > 0
      })
    },
    buildItemReceitaPayload() {
      const itemReceitaPayload = {
        ...this.itemReceita,
      }

      if (this.isVolumeCaldaVazioOuZero(itemReceitaPayload.volumeCalda)) {
        delete itemReceitaPayload.volumeCalda
      }

      return itemReceitaPayload
    },
    hasVolumeCaldaInformado() {
      const value = this.itemReceita ? this.itemReceita.volumeCalda : null

      const parsed = this.parseNumberField(value)
      return parsed !== null && parsed > 0
    },
    hasValidAreaCalculationInputs() {
      if (!this.itemReceita || !this.itemReceita.calculaArea) {
        return false
      }

      if (this.itemReceita.msgArea === 'É necessário informar área manualmente.') {
        return false
      }

      const values = [
        this.itemReceita.nAplicacoes,
        this.itemReceita.dose,
        this.itemReceita.qtdeAdquirir,
        this.itemReceita.unidade,
      ]

      if (this.isVolumeCaldaObrigatorio()) {
        values.push(this.itemReceita.volumeCalda)
      }

      return values.every((value) => {
        if (value === null || value === undefined || value === '') {
          return false
        }

        if (typeof value === 'string' && value.trim() !== '' && Number.isNaN(Number(String(value).replace(',', '.')))) {
          return true
        }

        const parsed = Number(String(value).replace(',', '.'))
        return !Number.isNaN(parsed) && parsed > 0
      })
    },
    queueAreaCalculation() {
      if (this.areaCalculationDebounce) {
        clearTimeout(this.areaCalculationDebounce)
      }

      if (!this.hasValidAreaCalculationInputs()) {
        this.areaCalculationMessage = ''
        return
      }

      this.areaCalculationDebounce = setTimeout(() => {
        this.handleCalcularArea()
      }, 350)
    },
    getAreaAplicacaoLabel() {
      const unidadeDose = String(this.itemReceita && this.itemReceita.desc_unidade ? this.itemReceita.desc_unidade : '')
        .trim()
        .toLowerCase()
      const unidadeCalda = String(this.itemReceita && this.itemReceita.desc_unidade_calda ? this.itemReceita.desc_unidade_calda : '')
        .trim()
        .toLowerCase()

      if (!unidadeDose && !unidadeCalda) {
        return 'Área a tratar'
      }

      const unidadeDoseNormalizada = this.normalizeUnitText(unidadeDose)
      const unidadeCaldaNormalizada = this.normalizeUnitText(unidadeCalda)

      const caldaPorPlanta =
        unidadeCaldaNormalizada.includes('l/planta') ||
        unidadeCaldaNormalizada.includes('ml/planta') ||
        unidadeCaldaNormalizada.includes('por planta')

      const dosePorHectare =
        unidadeDoseNormalizada.includes('/ha') ||
        unidadeDoseNormalizada.includes(' ha') ||
        unidadeDoseNormalizada.includes('hectare')

      return caldaPorPlanta && !dosePorHectare
        ? 'Quantidade de plantas tratadas'
        : 'Área a tratar'
    },
    getProdutorOptionLabel(produtor) {
      if (!produtor) return ''

      return produtor.endereco
        ? `${produtor.nome} - Endereço: ${produtor.endereco}`
        : produtor.nome || ''
    },
    normalizeProdutoresResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const pagination = payload.pagination || {}

      this.produtoresTotalDisponivel = Number(
        pagination.total ||
        payload.total ||
        payload.count ||
        0
      )

      if (Array.isArray(payload.data)) return payload.data
      if (Array.isArray(payload.dados)) return payload.dados
      if (Array.isArray(payload.produtores)) return payload.produtores
      if (Array.isArray(payload)) return payload
      return []
    },
    syncProdutorSelecionadoFromTerm() {
      const termo = this.produtorAutocompleteTerm
        ? String(this.produtorAutocompleteTerm).trim()
        : ''

      if (!termo) {
        this.produtorSelecionado = {}
        return
      }

      const itemEncontrado = this.produtores.find(
        (item) => this.getProdutorOptionLabel(item) === termo
      )

      if (itemEncontrado) {
        this.produtorSelecionado.item = itemEncontrado
      }
    },
    handleProdutorAutocompleteInput() {
      this.syncProdutorSelecionadoFromTerm()

      const termo = this.produtorAutocompleteTerm
        ? String(this.produtorAutocompleteTerm).trim()
        : ''

      this.showProdutorAutocomplete = termo.length > 0

      if (this.produtorSearchDebounce) {
        clearTimeout(this.produtorSearchDebounce)
      }

      this.produtorSearchDebounce = setTimeout(() => {
        if (!termo) {
          this.produtores = []
          this.produtoresTotalDisponivel = 0
          return
        }

        this.handleConsultarProdutores(termo)
      }, 250)
    },
    handleProdutorAutocompleteFocus() {
      const termo = this.produtorAutocompleteTerm
        ? String(this.produtorAutocompleteTerm).trim()
        : ''

      this.showProdutorAutocomplete = termo.length > 0
    },
    handleProdutorAutocompleteBlur() {
      setTimeout(() => {
        this.showProdutorAutocomplete = false
      }, 180)
    },
    handleSelecionarProdutor(item) {
      this.produtorSelecionado.item = item
      this.produtorAutocompleteTerm = this.getProdutorOptionLabel(item)
      this.showProdutorAutocomplete = false
    },
    getAgronomoGroupKey(agronomo) {
      return String(agronomo && agronomo.nome ? agronomo.nome : '').trim().toLowerCase()
    },
    getAgronomoArtLabel(agronomo) {
      const artPrimaria = String((agronomo && agronomo.art_primaria) || '').trim()
      const artImpressao = String((agronomo && agronomo.art_impressao) || '').trim()
      const crea = String((agronomo && agronomo.crea) || '').trim()

      if (artPrimaria && artImpressao && artPrimaria !== artImpressao) {
        return `${artPrimaria} / ${artImpressao}`
      }
      if (artPrimaria) return artPrimaria
      if (artImpressao) return artImpressao
      if (crea) return crea
      return 'Sem ART'
    },
    normalizeAddressValue(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    getAgronomoAddressLabel(agronomo) {
      const parts = [
        agronomo && agronomo.logradouro,
        agronomo && agronomo.numero,
        agronomo && agronomo.complemento,
      ]
        .map((item) => String(item || '').trim())
        .filter((item) => item !== '')

      return parts.join(' ')
    },
    syncProdutorByAgronomoEndereco(agronomo) {
      if (!this.separarArtPorTecnico || !agronomo) return

      const enderecoAgronomo = this.normalizeAddressValue(this.getAgronomoAddressLabel(agronomo))
      if (!enderecoAgronomo) return

      const produtorMatch = (this.produtores || []).find((produtor) => {
        const enderecoProdutor = this.normalizeAddressValue(produtor && produtor.endereco)
        if (!enderecoProdutor) return false

        return (
          enderecoProdutor.includes(enderecoAgronomo) ||
          enderecoAgronomo.includes(enderecoProdutor)
        )
      })

      if (produtorMatch) {
        this.produtorSelecionado.item = produtorMatch
        this.produtorAutocompleteTerm = this.getProdutorOptionLabel(produtorMatch)
      }
    },
    atualizarAgronomosAgrupados() {
      const usados = {}
      this.agronomosAgrupados = (this.agronomos || []).reduce((acc, agronomo) => {
        const key = this.getAgronomoGroupKey(agronomo)
        if (!key || usados[key]) return acc

        usados[key] = true
        acc.push({
          key,
          nome: agronomo.nome,
        })
        return acc
      }, [])
    },
    sincronizarAgronomoBaseSelecionado(agronomo) {
      if (!agronomo) {
        this.agronomoBaseSelecionado = null
        return
      }

      const key = this.getAgronomoGroupKey(agronomo)
      this.agronomoBaseSelecionado = this.agronomosAgrupados.find((item) => item.key === key) || null
    },
    handleSelecionarResponsavelTecnico(item) {
      this.agronomoBaseSelecionado = item
      this.agronomoSelecionado.item = this.artOptionsByTecnico[0] || null
      this.syncProdutorByAgronomoEndereco(this.agronomoSelecionado.item)
      this.$forceUpdate()
    },
    handleSelecionarArt(item) {
      this.agronomoSelecionado.item = item
      this.syncProdutorByAgronomoEndereco(item)
      this.$forceUpdate()
    },
    applyConfigReceitaAlertaArt(config) {
      var limite = Number(config && config.qtde_receita_alerta_art)
      var email = String((config && config.email_alerta_art) || '').trim()
      var limiteValido = !Number.isNaN(limite) && limite > 0
      var emailValido = email !== ''

      if (limiteValido) {
        this.qtdeReceitaAlertaArt = limite
      }
      this.emailAlertaArtConfigurado = email
      this.configAlertaArtValida = limiteValido && emailValido
    },
    loadConfigReceitaAlertaArt() {
      try {
        const config = JSON.parse(window.localStorage.getItem('configuracao'))
        this.applyConfigReceitaAlertaArt(config || {})
      } catch (error) {
        this.qtdeReceitaAlertaArt = 10
        this.emailAlertaArtConfigurado = ''
        this.configAlertaArtValida = false
      }
    },
    async refreshConfigReceitaAlertaArtFromApi() {
      try {
        const token = this.$store.state.auth.currentUser.token
        const response = await configuracoesService.listar(token)
        const configApi = response &&
          response.data &&
          response.data.configuracoes &&
          response.data.configuracoes[0]
          ? response.data.configuracoes[0]
          : null

        if (!configApi) return

        this.applyConfigReceitaAlertaArt(configApi)
        window.localStorage.setItem('configuracao', JSON.stringify(configApi))
      } catch (error) {
        // mantém o valor atual caso a API de configuração falhe
      }
    },
    getReceitaArtDisponivel(agronomo) {
      const valor = Number(agronomo && agronomo.receita_art_disponivel)
      return Number.isNaN(valor) ? 0 : valor
    },
    isSaldoReceitaAbaixoAlerta(agronomo) {
      return this.getReceitaArtDisponivel(agronomo) < this.qtdeReceitaAlertaArt
    },
    async enviarAlertasArtAutomaticos() {
      if (this.envioAlertaArtAutomaticoExecutado) return

      var emailDestino = String(this.emailAlertaArtConfigurado || '').trim()
      if (!emailDestino || !this.qtdeReceitaAlertaArt) return

      var token = this.$store.state.auth.currentUser.token
      var elegiveis = (this.agronomos || []).filter((agronomo) => this.isSaldoReceitaAbaixoAlerta(agronomo))
      var enviados = 0
      var ignorados = 0
      var falhas = 0

      for (var i = 0; i < elegiveis.length; i += 1) {
        var agronomo = elegiveis[i]
        var artNumero = String(agronomo.art_primaria || agronomo.art_impressao || '').trim()
        if (!artNumero) {
          ignorados += 1
          continue
        }

        var saldo = this.getReceitaArtDisponivel(agronomo)
        var nReceitasArt = Number(agronomo.n_receitas_art)
        var receitasUsadas = null
        if (!Number.isNaN(nReceitasArt) && nReceitasArt >= 0) {
          receitasUsadas = nReceitasArt - saldo
          if (receitasUsadas < 0) receitasUsadas = 0
        }

        var payload = {
          email: emailDestino,
          agronomoNome: agronomo.nome || '',
          artNumero: artNumero,
          receitasRestantes: saldo,
          obs: `Envio automático de alerta. Limite configurado: ${this.qtdeReceitaAlertaArt}.`,
        }

        if (receitasUsadas !== null) {
          payload.receitasUsadas = receitasUsadas
        }

        try {
          var response = await configuracoesService.sendAlertaReceitaArt(token, payload)
          if (response && response.enviado === false) {
            falhas += 1
            continue
          }
          enviados += 1
        } catch (error) {
          falhas += 1
        }
      }

      this.envioAlertaArtAutomaticoExecutado = true
    },
    updateSelect() {
      this.$forceUpdate()
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.itemReceita[name]
      return $dirty ? !$error : null
    },
    hasEquipamentoAplicacaoSelecionado() {
      return !!(
        this.equipamentoSelecionado &&
        typeof this.equipamentoSelecionado === 'object' &&
        this.equipamentoSelecionado.nome
      )
    },
    resetForm() {
      this.filter = {
        numero_receita: '',
      }

      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    handleConsultarProdutores(search = '') {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      const termo = search ? String(search).trim() : ''
      const request = termo
        ? produtorRural.listarByFilter(token, termo, 1, 20)
        : produtorRural.listar(token, 1, 20)

      request
        .then((resposta) => {
          const items = this.normalizeProdutoresResponse(resposta)

          if (
            this.produtorSelecionado &&
            this.produtorSelecionado.item &&
            this.produtorSelecionado.item.id_produtor_rural &&
            !items.some(
              (item) =>
                item.id_produtor_rural ===
                this.produtorSelecionado.item.id_produtor_rural
            )
          ) {
            this.produtores = [this.produtorSelecionado.item, ...items]
          } else {
            this.produtores = items
          }

          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarAgronomo() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      return agronomoService
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.atualizarAgronomosAgrupados()

          if (this.receita && this.receita.agronomo && this.receita.agronomo.id_agronomo) {
            this.agronomoSelecionado.item = this.agronomos.find((item) => item.id_agronomo === this.receita.agronomo.id_agronomo) || this.receita.agronomo
          } else {
            this.agronomoSelecionado.item = this.agronomos[0]
          }

          this.sincronizarAgronomoBaseSelecionado(this.agronomoSelecionado.item)
          this.syncProdutorByAgronomoEndereco(this.agronomoSelecionado.item)
          this.enviarAlertasArtAutomaticos()
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarProduto(token)
        .then((resposta) => {
          this.isLoading = false
          this.produtos = resposta.data.produto
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarCultura(produto) {
      if (!this.hasProdutorSelecionado()) {
        this.filter.id_produto = null
        this.filter.id_cultura = null
        this.culturas = []
        this.alvos = []
        this.notifyProdutorRequired()
        return
      }

      if (produto == null) {
        this.filter.id_produto = null
        this.filter.id_cultura = null
        return
      }

      this.filter.id_produto = produto
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarCulturaPorProduto(token, produto)
        .then((resposta) => {
          this.isLoading = false
          this.culturas = resposta.data.cultura
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = false
        })
    },
    handleConsultarAlvos(cultura) {
      if (!this.hasProdutorSelecionado()) {
        this.filter.id_cultura = null
        this.alvos = []
        this.notifyProdutorRequired()
        return
      }

      this.filter.id_cultura = cultura
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarAlvoPorProdutoCultura(
          token,
          this.filter.id_cultura,
          this.filter.id_produto
        )
        .then((resposta) => {
          this.isLoading = false
          this.alvos = resposta.data.alvo
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = false
        })
    },
    async handleConsultarRelacao(alvo) {
      if (!this.hasProdutorSelecionado()) {
        this.notifyProdutorRequired()
        return
      }

      if (this.receita.complementar) {
        if (!this.receita.receitaOrigem || !this.receita.artOrigem || !this.receita.dataNfOrigem) {
          this.$bvToast.toast('Receita marcada como complementar. Preencha obrigatoriamente o número da receita de origem, a ART de origem e a data da NF de origem.', {
            title: 'Validação',
            variant: 'danger',
            solid: true,
          });
          return;
        }
      }
      this.filter.id_pragas = alvo
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      try {
        const resposta = await receitaService.consultarRelacao(
          token,
          this.filter.id_produto,
          this.filter.id_cultura,
          this.filter.id_pragas,
          this.produtorSelecionado.item.id_produtor_rural
        )

        const relacoes = Array.isArray(resposta.data) ? resposta.data : []
        const relacoesPermitidas = await this.validarRegrasProdutosPorReceita(relacoes)
        this.relacoes = relacoesPermitidas

        if (this.relacoes.length) {
          this.$bvModal.show('bv-modal-relacao')
        }
      } catch (error) {
        this.idReceita = 0
        // const msg = error && error.response && error.response.data && error.response.data.aviso
        //   ? error.response.data.aviso.mensagem
        //   : 'Não foi possível consultar as relações para este produto.'
        // this.$bvToast.toast(msg, {
        //   variant: 'danger',
        //   solid: false,
        //   noCloseButton: true,
        //   toaster: 'b-toaster-top-center',
        // })
      } finally {
        this.isLoading = false
      }
    },
    async abrirReceita() {
      if (this.receita == null || this.receita.id == null) {
        const receitaSent = {}

        receitaSent.produtorRural = {
          idProdutorRural: this.produtorSelecionado.item.id_produtor_rural,
        }
        receitaSent.agronomo = {
          idAgronomo: this.agronomoSelecionado.item.id_agronomo,
        }
        receitaSent.nf = this.receita.nf
        receitaSent.serieNf = this.receita.serie_nf
        var valor = currencyFormatter.unformat(this.receita.valor_nf, {
          locale: 'pt-BR',
          code: 'BRL',
        })
        receitaSent.valorNf = valor

        receitaSent.receitaOrigem = this.receita.receitaOrigem
        receitaSent.artOrigem = this.receita.artOrigem
        receitaSent.dataNfOrigem = this.receita.dataNfOrigem
        receitaSent.complementar = this.receita.complementar

        const token = this.$store.state.auth.currentUser.token
        const response = await receitaService
          .abrirReceita(token, receitaSent)
          .catch((error) => {
            this.isLoading = false
            const msg = error.response.data.aviso.mensagem
            this.$bvToast.toast(msg, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return response.data.sucesso.idReceita
      }
      return this.receita.id
    },
    async adicionarItemReceita(id) {
      if (id != null) {
        if (!this.hasEquipamentoAplicacaoSelecionado()) {
          this.$bvToast.toast('Selecione o equipamento de aplicação antes de adicionar o item.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        this.itemReceita.descEquipamentoAplicacao = this.equipamentoSelecionado.nome
        const token = this.$store.state.auth.currentUser.token
        this.itemReceita.receita.idReceita = id
        const relacaoSelecionadaId = this.getRelacaoId(this.itemReceita)
        const itemReceitaPayload = this.buildItemReceitaPayload()
        const response = await receitaService
          .addItemReceita(token, itemReceitaPayload)
          .catch((error) => {
            const msg = error.response.data.aviso.mensagem
            this.$bvToast.toast(msg, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.itensReceita.push(this.itemReceita)
          })
        if (response != undefined) {
          if (Number.isFinite(relacaoSelecionadaId)) {
            this.relacoesAtuaisReceita = Array.from(
              new Set([...this.relacoesAtuaisReceita, relacaoSelecionadaId])
            )
          }
          this.itemReceita = null
        }

        return response
      }
    },
    async criarReceita() {
      this.$v.itemReceita.$touch()
      if (this.$v.itemReceita.$anyError) {
        return
      }

      if (!this.hasEquipamentoAplicacaoSelecionado()) {
        this.$bvToast.toast('Selecione o equipamento de aplicação antes de adicionar o item.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.isLoading = true

      const id = await this.abrirReceita()

      const responseItemReceita = await this.adicionarItemReceita(id)
      if (responseItemReceita == undefined) {
        this.isLoading = false
        return
      }

      await this.consultarItemReceita(id)
      this.receita.id = id
      this.isLoading = false
    },

    selecionarRelacao(relacao) {
      this.$bvModal.hide('bv-modal-relacao')
      this.itemReceita = new ItemReceita()
      this.areaCalculationMessage = ''

      this.itemReceita.receita.idReceita = this.receita.id
      this.itemReceita.produtor = this.produtorSelecionado.item.nome
      this.itemReceita.agronomo = this.agronomoSelecionado.item.nome
      this.itemReceita.cultura.idCultura = relacao.idCultura
      this.itemReceita.cultura.nomeComumCultura = relacao.nomeComumCultura
      this.itemReceita.cultura.nomeCientificoCultura =
        relacao.nomeCientificoCultura
      this.itemReceita.praga.idPragas = relacao.idAlvo
      this.itemReceita.praga.nomeComumPraga = relacao.nomeComumPraga
      this.itemReceita.praga.nomeCientificoPraga = relacao.nomeCientificoPraga
      this.itemReceita.produto.idProduto = relacao.idProduto
      this.itemReceita.produto.nome = relacao.nome
      this.itemReceita.localAplicacao.idLocalAplicacao =
        relacao.idLocalAplicacao
      this.itemReceita.dose = relacao.doseMin
      this.itemReceita.doseMin = relacao.doseMin
      this.itemReceita.doseMax = relacao.doseMax
      this.itemReceita.volumeCalda = relacao.volumeCalda
      this.itemReceita.volumeCaldaMin = relacao.volumeCaldaMin
      this.itemReceita.volumeCaldaReferencia = relacao.volumeCalda
      this.itemReceita.volumeCaldaMinReferencia = relacao.volumeCaldaMin
      this.itemReceita.nAplicacoes = relacao.numeroAplicacoesMin
      this.itemReceita.numeroAplicacoesMin = relacao.numeroAplicacoesMin
      this.itemReceita.numeroAplicacoesMax = relacao.numeroAplicacoesMax
      this.itemReceita.descEquipamentoAplicacao = relacao.descEpi
      this.itemReceita.descRecomendacoes = relacao.descPrecaucaoUso
      this.itemReceita.descModoAplicacao = relacao.descModoAplicacao
      this.itemReceita.unidade = null
      this.itemReceita.unidadeCalculo = relacao.idUnidadeDose
      this.itemReceita.desc_unidade = relacao.unidadeAplicacao
      this.itemReceita.desc_unidade_calda = relacao.unidadeCultura || ''
      this.itemReceita.ingredientes = relacao.ingredientes
      this.itemReceita.calculaArea = relacao.calculaArea
      this.itemReceita.msgArea = relacao.msgArea
      this.itemReceita.idItemProduto = relacao.id


      const objetoEncontrado = this.equipamentos.find(objeto => objeto.nome === relacao.tipoAplicacao);
      this.equipamentoSelecionado = objetoEncontrado
    },

    async consultarItemReceita(id) {
      if (id != null) {
        const token = this.$store.state.auth.currentUser.token

        const response = await receitaService.consultarItemReceita(token, id)
        this.receita.receitaOrigem = response.data.receitaOrigem
        this.receita.artOrigem = response.data.artOrigem
        this.receita.dataNfOrigem = response.data.dataNfOrigem
        this.receita.complementar = response.data.complementar
        this.itens = response.data.itens
        const relacoesRetornadas = ((response.data && response.data.itens) || [])
          .map((item) => this.getRelacaoId(item))
          .filter((value) => Number.isFinite(value))

        this.relacoesAtuaisReceita = Array.from(
          new Set(
            [...this.relacoesAtuaisReceita, ...relacoesRetornadas]
          )
        )
      }
    },

    modalDeleteItemReceita(id) {
      this.modalDelItem = true
      this.idItemReceita = id
    },

    handleDeleteItemReceita() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      receitaService
        .delItemReceita(token, this.idItemReceita)
        .then((resposta) => {
          this.consultarItemReceita(this.receita.id)
          this.modalDelItem = false
          this.isLoading = false
        })
        .catch((error) => {
          this.modalDelItem = false
          this.isLoading = false
        })
    },

    handleEmitirReceita() {
      momentTimeZone.tz.setDefault('America/Sao_Paulo');
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      const dataHoraBrasil = momentTimeZone(this.dataEmissaoReceituario).format('YYYY-MM-DD');
      const data = {
        idReceita: this.receita.id,
        dataEmissao: dataHoraBrasil,
      }

      receitaService
        .emitir(token, data)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Receita emitda com sucesso', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.baixaEstoqueReceituario(token, this.receita.id)
          this.$root.$emit('back')
        })
        .catch((error) => {
          this.isLoading = false
          const msg = error.response.data.aviso.mensagem
          this.$bvToast.toast(msg, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },

    async baixaEstoqueReceituario(token, id) {
      var config = JSON.parse(window.localStorage.getItem('configuracao'))
      if (config.baixa_estoque_receituario) {
        await estoqueService.baixaReceituario(token, id)
      }
    },

    handleCalcularArea() {
      if (!this.hasValidAreaCalculationInputs()) {
        this.areaCalculationMessage = ''
        return
      }

      if (
        this.itemReceita.calculaArea &&
        this.itemReceita.msgArea !== 'É necessário informar área manualmente.'
      ) {
        const parseNumericValue = (value) => {
          if (value === null || value === undefined || value === '') {
            return null
          }

          const parsed = Number(String(value).replace(',', '.'))
          return Number.isNaN(parsed) ? null : parsed
        }

        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        const payload = {
          relacao: parseNumericValue(this.itemReceita.idItemProduto),
          numeroAplicacoes: parseNumericValue(this.itemReceita.nAplicacoes),
          dose: parseNumericValue(this.itemReceita.dose),
          quantidade: parseNumericValue(this.itemReceita.qtdeAdquirir),
          unidadeQuantidade: this.itemReceita.unidade,
        }

        if (this.hasVolumeCaldaInformado()) {
          payload.calda = parseNumericValue(this.itemReceita.volumeCalda)
        }

        receitaService
          .calcularArea(token, payload)
          .then((resposta) => {
            const limite = 1000000;
            const area =
              resposta &&
                resposta.data &&
                resposta.data.value !== undefined
                ? Number(resposta.data.value)
                : resposta &&
                  resposta.data &&
                  resposta.data.sucesso &&
                  resposta.data.sucesso.area !== undefined
                  ? Number(resposta.data.sucesso.area)
                  : resposta &&
                    resposta.data &&
                    resposta.data.area !== undefined
                    ? Number(resposta.data.area)
                    : resposta &&
                      resposta.data &&
                      resposta.data.data &&
                      resposta.data.data.area !== undefined
                      ? Number(resposta.data.data.area)
                      : 0
            let numeroFormatado = area > limite ? parseFloat((area / 1000).toFixed(3)) : parseFloat(area.toFixed(2));
            this.itemReceita.areaAplicacao = numeroFormatado == 0 ? 1 : numeroFormatado
            this.areaCalculationMessage =
              resposta && resposta.data && resposta.data.message
                ? resposta.data.message
                : ''
            this.isLoading = false
          })
          .catch((error) => {
            this.modalDelItem = false
            this.areaCalculationMessage = ''
            this.isLoading = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  b {
    color: #008e75;
  }

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-emitir {
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 15px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.item-editor-complementar {
  padding: 20px 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcfb 100%);
  border: 1px solid #dcebe7;
}

.item-editor-complementar .item-summary-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(280px, 1fr);
  gap: 0;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4efec;
}

.item-editor-complementar .item-summary-card {
  min-height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
}

.produtor-autocomplete {
  position: relative;
}

.produtor-autocomplete-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 40;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #d9e4ec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
}

.regra-produto-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.regra-produto-resumo {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dcebe7;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbfa 100%);
}

.regra-produto-uf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  height: 50px;
  border-radius: 14px;
  background: #0f8d76;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.regra-produto-resumo-texto {
  min-width: 0;
}

.regra-produto-mensagem-principal {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: #163b35;
}

.regra-produto-estado {
  margin-top: 4px;
  font-size: 12px;
  color: #5b766f;
}

.regra-produto-metricas {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.regra-produto-metrica {
  padding: 10px 12px;
  border: 1px solid #dcebe7;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}

.regra-produto-metrica-valor {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #0f8d76;
}

.regra-produto-metrica-label {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #5b766f;
}

.regra-produto-bloco {
  padding: 12px 14px;
  border: 1px solid #dcebe7;
  border-radius: 12px;
  background: #f8fcfb;
}

.regra-produto-titulo {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #0f4c45;
}

.regra-produto-lista {
  margin: 0;
  padding-left: 18px;
}

.regra-produto-lista li + li {
  margin-top: 6px;
}

.regra-produto-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.regra-produto-flag {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #e8f5f1;
  color: #0f4c45;
  font-size: 12px;
  font-weight: 600;
}

.regra-produto-fundamento {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 12px;
  color: #5b766f;
}

@media (max-width: 767px) {
  .regra-produto-resumo {
    padding: 12px;
  }

  .regra-produto-uf {
    min-width: 42px;
    height: 42px;
    border-radius: 12px;
    font-size: 15px;
  }

  .regra-produto-metricas {
    grid-template-columns: 1fr;
  }
}

.produtor-autocomplete-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  background: transparent;
  text-align: left;
  transition: background-color 0.15s ease;
}

.produtor-autocomplete-item:hover {
  background: #f1f8f6;
}

.produtor-autocomplete-name {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
}

.produtor-autocomplete-meta {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.produtor-autocomplete-state {
  padding: 12px;
  color: #64748b;
  font-size: 13px;
}

.summary-line+.summary-line {
  margin-top: 6px;
}

.item-editor-complementar .summary-pill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.item-editor-complementar .summary-inline {
  display: grid;
  grid-template-columns: 116px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}

.item-editor-complementar .summary-inline-pairs {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.item-editor-complementar .summary-inline-pair {
  min-width: 180px;
  flex: 1 1 220px;
}

.item-editor-complementar .summary-label {
  display: block;
  margin-bottom: 0;
  color: #0b8a73;
  font-size: 10px;
  font-weight: 700;
  padding-top: 1px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.item-editor-complementar .summary-value {
  display: block;
  color: #334761;
  font-size: 13px;
  line-height: 1.35;
}

.item-editor-complementar .summary-pill {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 999px;
  background: #dfece7;
  color: #26463f;
  line-height: 1.4;
}

.item-editor-complementar .summary-action {
  margin-top: 12px;
}

.item-editor-complementar .item-summary-card .summary-value,
.item-editor-complementar .item-summary-card .summary-label {
  word-break: break-word;
}

.item-editor-complementar .item-summary-grid .item-summary-card+.item-summary-card {
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid #e4efec;
}

.item-editor-complementar .item-editor-section {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e4efec;
}

.item-editor-complementar .item-editor-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
}

.item-editor-inline-note {
  max-width: 320px;
  padding: 8px 12px;
  border: 1px solid #dcebe7;
  border-radius: 999px;
  background: #f6fbfa;
  color: #4b6b66;
  font-size: 12px;
  line-height: 1.4;
}

.item-form-inline-hint {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-left: 3px solid #bfe4db;
  border-radius: 8px;
  background: #f8fcfb;
  color: #64807a;
  font-size: 12px;
  line-height: 1.45;
}

.item-editor-complementar .item-editor-section-title {
  margin: 0 0 2px;
  color: #1d4d45;
  font-size: 16px;
  font-weight: 700;
}

.item-editor-complementar .item-editor-section-text {
  margin: 0;
  color: #64807a;
  font-size: 12px;
}

.item-editor-complementar .item-textareas-row .form-control {
  min-height: 128px;
}

.item-editor-complementar .item-editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 2px;
  padding-top: 8px;
}

.item-editor-complementar .item-editor-actions .btn {
  min-width: 116px;
  border-radius: 10px;
  font-weight: 600;
  padding: 0.45rem 1rem;
}

@media (max-width: 1199.98px) {
  .item-editor-complementar .item-summary-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .item-editor-complementar .item-summary-grid .item-summary-card+.item-summary-card {
    margin-left: 0;
    padding-left: 0;
    padding-top: 10px;
    border-left: 0;
    border-top: 1px solid #e4efec;
  }
}

@media (max-width: 767.98px) {
  .item-editor-complementar {
    padding: 16px;
  }

  .item-editor-inline-note {
    max-width: 100%;
  }

  .item-editor-complementar .summary-inline {
    grid-template-columns: 1fr;
    gap: 1px;
  }

  .item-editor-complementar .summary-inline-pairs {
    gap: 10px;
  }

  .item-editor-complementar .summary-inline-pair {
    min-width: 100%;
  }

  .item-editor-complementar .item-editor-actions {
    flex-direction: column-reverse;
  }

  .item-editor-complementar .item-editor-actions .btn {
    width: 100%;
  }
}
</style>
